import { LinkedRecord } from 'screens/Applications&WorkOrders/WorkOrders/Hooks/linkedRecords.types';

/** Names shown before "+ N more". A count of names, not of rendered lines. */
export const LINKED_RECORD_NAME_LIST_CAP = 8;

/** Shared by the table and the Overview Drawer so both read dates identically. */
export const DATE_TIME_FORMAT = 'MMM DD, YYYY hh:mmA';

export interface LinkedRecordsState {
  records: LinkedRecord[];
  totalRecords: number;
  isLoading: boolean;
  hasError: boolean;
  page: number;
  onPageChange: (page: number) => void;
}
